import { AsyncStore } from '~/lib/store/AsyncStore';
import { RegisteredDomain } from '~/lib/ApiModel';
import { ISiteServicesApiClient } from '~/lib/SiteServicesApiClient';
import { notFoundAsUndefined } from '../helper/RequestHelper';

export class RegisteredDomainsStore extends AsyncStore<
    (RegisteredDomain | undefined)[],
    (RegisteredDomain | undefined)[]
> {
    constructor(
        private siteApiClient: ISiteServicesApiClient,
        public domainNames: string[]
    ) {
        super(async () => {
            const domainsPromises = this.domainNames.map(async (domainName) => {
                const domainLoader = notFoundAsUndefined(() => this.siteApiClient.getRegisteredDomain(domainName));
                return await domainLoader();
            });

            return await Promise.all(domainsPromises);
        }, []);
    }
}

export default RegisteredDomainsStore;
